<template>
  <div class="data-box">
    <el-divider content-position="left">基础信息</el-divider>
    <div class="name-box flex">
      <div class="name">昵称</div>
      <el-input v-model="nickname" maxlength="10" show-word-limit />
      <el-button type="primary" :loading="name_loading" @click="setName()">修 改</el-button>
    </div>
    <div style="height: 20px"></div>
    <div class="tel-box flex">
      <div class="name">手机号</div>
      <el-input v-model="regtel" maxlength="11" show-word-limit v-on:input="limitNumber('regtel')" />
      <el-button type="primary" @click="openReg">绑 定</el-button>
    </div>
    
    <el-divider content-position="left">证件绑定</el-divider>
    <div style="width: 920px">
      <el-alert title="1、第一张绑定的身份证默认为主证件" type="warning" :closable="false" />
      <div style="height: 10px"></div>
      <el-alert title="2、主证件年龄大于18岁可绑定两张子证件（小于18岁则不能绑定子证件）" type="warning" :closable="false" />
    </div>
    <div style="height: 20px"></div>
    <div class="idcard-box">
      <div class="item" v-for="(v, index) in userList" :key="v.id" :class="`item-${index}`" >
        <div><span>姓名</span>：{{v.truename}}</div>
        <div style="height: 10px"></div>
        <div><span>性别</span>：{{getSexIdcard(v.idcard)[1]}}</div>
        <div style="height: 10px"></div>
        <div><span>身份证</span>：{{hideZj(v.idcard, 4, 4, 8)}}</div>
        <div class="relieve" @click="handelRelieve(index)">解 绑</div>
      </div>

      <div class="item add" alt="" @click="addIdcard" v-show="isAddBtn"></div>
    </div>
    <div style="height: 50px"></div>
    <!-- 手机号验证码 -->
    <el-dialog
      v-model="dialogVisible"
      title="绑定手机号"
      :width="'500px'"
    >
      <div class="tel-box flex">
        <div class="name">手机号</div>
        <el-input v-model="regtel" disabled />
      </div>
      <div style="height: 20px"></div>
      <div class="tel-box flex">
        <div class="name">验证码</div>
        <el-input v-model="codeReg" v-on:input="limitNumber('codeReg')" />
        <el-button type="success" @click="getSms" v-if="isPost" :loading="code_loading">获取验证码</el-button>
        <el-button type="info" disabled v-else>{{codeTxt}}S后获取</el-button>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="validateCode()" :loading="post_loading">绑 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 百度识别添加身份证 -->
    <el-dialog
      v-model="idcardVisible"
      title="添加身份证"
      width="640px"
    >
      <IdcardImg ref="idcard" />
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="idcardVisible = false">取 消</el-button>
          <el-button type="primary" @click="handelImgBtn()" :loading="post_loading">绑 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 手动输入 -->
    <el-dialog
      v-model="textVisible"
      title="未成年身份证录入"
      width="500px"
    >
      <div class="name-box flex">
        <div class="name">姓名</div>
        <el-input v-model="name" maxlength="5" v-on:input="limitHanzi('name')" show-word-limit placeholder="限汉字录入" />
      </div>
      <div style="height: 20px"></div>
      <div class="name-box flex">
        <div class="name">身份证</div>
        <el-input v-model="card" maxlength="18" v-on:input="limitNumber1('card')" show-word-limit />
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="textVisible = false">取 消</el-button>
          <el-button type="primary" @click="handelTxtBtn()">绑 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 解绑主账号 -->
    <el-dialog
      v-model="relieveVisible"
      title="身份证解绑"
      width="500px"
    >
      <el-alert title="解绑主证件会默认解除所有子证件" type="warning" show-icon :closable="false" />
      <div style="height: 20px"></div>
      <div class="name-box flex">
        <div class="name tips">身份证</div>
        <el-input v-model="remove_card" maxlength="18" v-on:input="limitNumber1('card')" show-word-limit placeholder="请输入主证件的身份证号码" />
      </div>
      <div style="height: 20px"></div>
      <div class="tel-box flex">
        <div class="name tips">手机号</div>
        <el-input v-model="remove_tel" maxlength="11" show-word-limit v-on:input="limitNumber('regtel')" placeholder="请输入联系电话" />
      </div>
      <div style="height: 20px"></div>
      <div class="tel-box flex">
        <div class="name">留言</div>
        <el-input
          v-model="remove_msg"
          :rows="4"
          type="textarea"
        />
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="relieveVisible = false">取 消</el-button>
          <el-button type="primary" @click="relieveMaster()">解 绑</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElNotification, ElMessageBox } from 'element-plus'
import { reactive, toRefs, watch, onBeforeUnmount, ref } from "vue"
import { useStore } from "vuex"
import { validateTel, hideZj, getSexIdcard, getAgeIdcard, validateIdent } from "@/tools"
import { api } from "@/api"
import IdcardImg from "@/components/common/user/idcardImg.vue"
export default {
  components: {
    IdcardImg
  },
  setup() {
    let store = useStore()
    let idcard = ref(null)
    let initData = reactive({
      isLogin: "",
      userInfo: "",
      hideZj,
      getSexIdcard,
      
      name_loading: false,
      nickname: "",
      regtel: "",
      dialogVisible: false,

      // 短信验证
      codeReg: "", // 验证码
      codeTxt: 120, // 倒计时
      code_loading: false, // 短信请求状态
      isPost: true, // 是否可以获取验证码
      timer: "",
      post_loading: false, // 资料提交loading

      // 子账号
      isAddBtn: false, // 是否显示添加按钮
      userList: "",
      addType: -1, // 0 添加主账号 1 天剑子账号
      idcardVisible: false,

      // 手动输入身份证
      textVisible: false,
      name: "",
      card: "",
      // 解绑主账号
      relieveVisible: false,
      remove_card: "",
      remove_tel: "",
      remove_msg: "",


    })
    watch(() => store.state.userInfo, (newVal) => {
      initData.userInfo = newVal
      if(newVal) {
        initData.isLogin = true
        initData.nickname = initData.userInfo.nickname
        initData.regtel = initData.userInfo.regtel
      } else {
        initData.isLogin = false
      }
    }, {immediate: true, deep: true})
    // 限制数字
    function limitNumber(key) {
      setTimeout(() => {
        initData[key] = initData[key].replace(/[^\d]/g, '')
      },100)
    }
    function limitNumber1(key) {
      setTimeout(() => {
        initData[key] = initData[key].replace(/[^\d|xX]/g, '')
      },100)
    }
    // 限制中文
    function limitHanzi(key) {
      setTimeout(() => {
        initData[key] = initData[key].replace(/[^\u4e00-\u9fa5|,]+/g, '')
      },100)
    }
    // 修改昵称
    function setName() {
      if(initData.nickname) {
        initData.name_loading = true
        api("post", "userinfo", {id: initData.userInfo.id, nickname: initData.nickname}).then(res => {
          initData.name_loading = false
          if(res.code === 1200) {

            initData.userInfo.nickname = JSON.parse(JSON.stringify(initData.nickname))
            // 更新本地用户信息
            store.commit("setUserInfo", initData.userInfo)
            localStorage.setItem("whgUserInfo", JSON.stringify(initData.userInfo))
            ElNotification({
              title: '提示',
              message: '昵称修改成功',
              type: 'success',
            })
          } else {
            ElNotification({
              title: '提示',
              message: res.msg,
              type: 'error',
            })
          }
        })
        .catch(err => {
          initData.name_loading = false
          ElNotification({
            title: '提示',
            message: '昵称修改失败，请重新尝试',
            type: 'error',
          })

        })
      } else {
        ElMessage.warning('请填写用户名')
      }
    }
    // 打卡短信验证码层
    function openReg() {
      if(validateTel(initData.regtel)) {
        initData.dialogVisible = true
      } else {
        ElMessage.warning('请输入正确的手机号码')
      }
    }
    // 获取短信验证码
    function getSms() {

      initData.code_loading = true
      let data = {
        phone: initData.regtel,
        type: 2, // 绑定手机
        appcode: initData.userInfo.appcode,
      }
      api("get", "smsSignCodeByPc", data).then(res => {
        initData.code_loading = false
        if(res.code == 1200) {
          initData.isPost = false
          count_down()
        } else {
          ElNotification({
            title: '提示',
            message: '验证码获取失败，请重新尝试',
            type: 'error',
          })
        }
      })
      .catch(err => {
        initData.code_loading = false
        ElNotification({
          title: '提示',
          message: '验证码获取失败，请重新尝试',
          type: 'error',
        })
      })
    }
    // 验证码验证
    function validateCode() {
      if(!initData.codeReg) {
        ElMessage.warning('请输入验证码')
        return
      }
      initData.post_loading = true
      api("get", "checkSmsCode", {phone: initData.regtel, smsCode: initData.codeReg}).then(res => {
        if(res.code == 1200) {
          
          setPhone()
        } else {
          initData.post_loading = false
          ElNotification({
            title: '提示',
            message: '验证码校验失败，请重新尝试',
            type: 'error',
          })
        }
      })
      .catch(err => {{
        initData.post_loading = false
        ElNotification({
          title: '提示',
          message: '验证码校验失败，请重新尝试',
          type: 'error',
        })
      }})
    }
    // 修改手机号
    function setPhone() {
      api("post", "userinfo", {id: initData.userInfo.id, regtel: initData.regtel}).then(res => {
        initData.post_loading = false
        if(res.code == 1200) {
          initData.dialogVisible = false
          initData.timer && clearInterval(initData.timer)
          initData.userInfo.regtel = JSON.parse(JSON.stringify(initData.regtel))
          // 更新本地用户信息
          store.commit("setUserInfo", initData.userInfo)
          localStorage.setItem("whgUserInfo", JSON.stringify(initData.userInfo))
          ElNotification({
            title: '提示',
            message: '手机号绑定成功',
            type: 'success',
          })
        } else {
          ElNotification({
            title: '提示',
            message: '手机号绑定失败，请重新尝试',
            type: 'error',
          })
        }
      })
      .catch(err => {
        initData.post_loading = false
        ElNotification({
          title: '提示',
          message: '手机号绑定失败，请重新尝试',
          type: 'error',
        })

      })
    }
    // 倒计时
    function count_down() {
      initData.timer = setInterval(() => {
        if(initData.codeTxt > 0) {
          initData.codeTxt --
        } else {
          initData.codeTxt = 120
          initData.isPost = true
          clearInterval(initData.timer)
        }
      },1000)
    }
    // 获取全部绑定证件
    function getUserList() {
      initData.isAddBtn = false
      initData.userList = []
      api("get", "getOtherOfUser", {uid: initData.userInfo.id, type: 1}).then(res => {
        if(res.code == 1200) {
          if(res.data[0].idcard) {
            
            initData.addType = 1
            let arr = []
            res.data.forEach(item => {
              if(item.id == initData.userInfo.id) {
                arr.unshift(item)
              } else {
                arr.push(item)
              }
            })
            if(getAgeIdcard(arr[0].idcard) >= 18 && arr.length < 3) {
              initData.isAddBtn = true
            }
            initData.userList = arr
          } else {
            initData.isAddBtn = true
            initData.addType = 0
          }
        }
      })
    }
    getUserList()
    // 添加证件
    function addIdcard() {
      ElMessageBox.confirm(
        '年满18岁只能选择自动识别方式上传身份证',
        '请选择身份证录入方式',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: '自动识别',
          cancelButtonText: '手动填写',
          type: 'warning',
        }
      )
        .then(() => {
          initData.idcardVisible = true
        })
        .catch((action) => {
          if(action === 'cancel') initData.textVisible = true
          
        })
      
    }
    // 手动录入身份证
    function handelTxtBtn() {
      if(!initData.name) {
        ElMessage.warning('请输入姓名')
        return
      }
      if(!initData.card) {
        ElMessage.warning('请输入身份证')
        return
      }
      if(!validateIdent(initData.card)) {
        ElMessage.warning('请输入正确的身份证号码')
        return
      }
      if(initData.addType === 0) { // 添加主账号
        let data = {
          id: initData.userInfo.id, 
          idcard: initData.card,
          truename: initData.name
        }
        setMaster(data)
      } else if(initData.addType === 1) { // 添加子账号
        if(getAgeIdcard(initData.card) >= 18) {
          ElMessage.warning('子证件年龄限制小于18岁')
          return
        }
        let data = {
          idcard: initData.card,
          parentId: initData.userInfo.id,
          password: "000000",
          truename: initData.name,
          username: initData.card
        };
        setChild(data)
      }
      
    }
    // 百度识别结果
    function handelImgBtn() {
      if(initData.addType === 0) { // 添加主账号
        if(idcard.value.idcard) {
          let data = {
            id: initData.userInfo.id, 
            idcard: idcard.value.idcard['公民身份号码'].words,
            truename: idcard.value.idcard['姓名'].words
          }
          setMaster(data)
        } else {
          ElMessage.warning('请上传身份证照片')
        }
      } else if(initData.addType === 1) { // 添加子账号
        if(idcard.value.idcard) {
          let sfz = idcard.value.idcard['公民身份号码'].words
          if(getAgeIdcard(sfz) >= 18) {
            ElMessage.warning('子证件年龄限制小于18岁')
            return
          }
          let data = {
            idcard: sfz,
            parentId: initData.userInfo.id,
            password: "000000",
            truename: idcard.value.idcard['姓名'].words,
            username: sfz
          };
          setChild(data)
        } else {
          ElMessage.warning('请上传身份证照片')
        }
        
      }
    }
    // 绑定身份证（主）
    function setMaster(postData) {
      initData.post_loading = true
      api("post", "userinfo", postData).then(res => {
        initData.post_loading = false
        if(res.code == 1200) {
          initData.idcardVisible = false
          initData.textVisible = false
          initData.userInfo.idcard = postData.idcard
          initData.userInfo.truename = postData.truename
          getUserList()
          // 更新本地用户信息
          store.commit("setUserInfo", initData.userInfo)
          localStorage.setItem("whgUserInfo", JSON.stringify(initData.userInfo))
          ElNotification({
            title: '提示',
            message: '身份证绑定成功',
            type: 'success',
          })
        } else {
          ElNotification({
            title: '提示',
            message: '身份证绑定失败，请重新尝试',
            type: 'error',
          })
        }
      })
      .catch(err => {
        initData.post_loading = false
        ElNotification({
          title: '提示',
          message: '身份证绑定失败，请重新尝试',
          type: 'error',
        })

      })
    }
    // 绑定身份证（子）
    function setChild(postData) {
      initData.post_loading = true
      api("post", "otherOfUser", postData).then(res => {

        initData.post_loading = false
        if(res.code == 1200) {
          initData.idcardVisible = false
          initData.textVisible = false

          getUserList()
          ElNotification({
            title: '提示',
            message: '身份证绑定成功',
            type: 'success',
          })
        } else {
          ElNotification({
            title: '提示',
            message: '身份证绑定失败，请重新尝试',
            type: 'error',
          })
        }
      })
      .catch(err => {
        initData.post_loading = false
        ElNotification({
          title: '提示',
          message: '身份证绑定失败，请重新尝试',
          type: 'error',
        })
      })
    }
    // 点击解绑按钮
    function handelRelieve(index) {
      if(index === 0) {
        initData.relieveVisible = true
        // relieveMaster(initData.userList[index])
      } else {
        relieveChild(initData.userList[index])
      }
    }
    // 解除绑定（主）
    function relieveMaster() {
      if(!initData.remove_card) {
        ElMessage.warning('请输入主证件号码')
        return
      }
      if(!initData.remove_tel) {
        ElMessage.warning('请输入联系电话')
        return
      }

      if(initData.remove_card != initData.userList[0].idcard) {
        ElMessage.warning('身份证不匹配')
        return
      }
      if(!validateTel(initData.remove_tel)) {
        ElMessage.warning('请输入正确的手机号码')
        return
      }
      let data = {
        id: initData.userInfo.id,
        remark: initData.remove_msg,
        phone: initData.remove_tel,
      };
      api("get", "removeUseIdCard", data).then(res=> {
        if(res.code == 1200) {
          initData.relieveVisible = false
          getUserList()
          ElNotification({
            title: '提示',
            message: '身份证已解除绑定',
            type: 'success',
          })
        } else {
          ElNotification({
            title: '提示',
            message: '身份证解除绑定失败，请重新尝试',
            type: 'error',
          })
        }
      })
    }
    // 解除绑定（子）
    function relieveChild(row) {
      ElMessageBox.confirm(
        `您确认解绑“${row.truename}”的证件？`,
        '子证件解绑',
        {
          confirmButtonText: '解绑',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          api("get", "delOtherOfUser", {id: row.id}).then(res=> {
            if(res.code == 1200) {
              getUserList()
              ElNotification({
                title: '提示',
                message: '身份证已解除绑定',
                type: 'success',
              })
            } else {
              ElNotification({
                title: '提示',
                message: '身份证解除绑定失败，请重新尝试',
                type: 'error',
              })
            }
          })
        })
        .catch(() => {
          
        })
      
    }
    onBeforeUnmount(() => {
      initData.timer && clearInterval(initData.timer)
    })
    return {
      ...toRefs(initData),
      limitNumber,
      limitNumber1,
      limitHanzi,
      setName,
      openReg,
      getSms,
      validateCode,
      addIdcard,
      handelImgBtn,
      handelTxtBtn,
      idcard,
      handelRelieve,
      relieveMaster
    }
  }
}
</script>

<style lang="less" scoped>
.data-box {
  
  .name-box,.tel-box {
    align-items: center;
    .name {
      width: 50px;
      color: #585858;
      text-align: justify;
      text-align-last: justify;

    }
    .tips {
      position: relative;
      &::before {
        content: "*";
        position: absolute;
        left: -8px;
        top: 4px;
        color: #ff5722;
      }
    }
    :deep(.el-input) {
      margin: 0 20px;
      width: 250px;
    }
    :deep(.el-textarea) {
      margin: 0 20px;
      width: 370px;
    }
  }
  .idcard-box {
    display: flex;
    
    // border: 1px solid #eee;
    .item-0 {
      background: #f4f4f5;
    }
    .item {
      width: 300px;
      height: 120px;
      border: 3px dashed #ddd;
      padding: 15px;
      border-radius: 5px;
      display: inline-block;
      box-sizing: border-box;
      vertical-align: top;
      margin-right: 10px;
      margin-bottom: 10px;
      color: #585858;
      position: relative;
      span {
        display: inline-block;
        width: 60px;
        text-align: justify;
        text-align-last: justify;
        vertical-align: top;
      }
      .relieve {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 26px;
        line-height: 1;
        cursor: pointer;
        border-radius: 2px;
        font-size: 14px;
        color: #fff;
        background-color: #ed6464;
        position: absolute;
        right: 10px;
        top: 10px;
        &:hover {
          background-color: #ce5454;
        }
      }
    }
    .add {
      position: relative;
      &::after {
        content: "";
        height: 80px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-left: 3px dashed #ddd;
      }
      &::before {
        content: "";
        width: 80px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-top: 3px dashed #ddd;
      }
      &:hover {
        border-color: #c0ccda;
        &::after,&::before {
          border-color: #c0ccda;
        }
      }
    }
  }
}
</style>